import icon1 from '../images/icon/research.gif'
import icon2 from '../images/icon/durability.gif'
import icon3 from '../images/icon/digital-tra.gif'
import icon4 from '../images/icon/business-develop.gif'
import icon5 from '../images/icon/search.gif'
import icon6 from '../images/icon/warning.gif'

import sicon1 from '../images/icon/ser-icon01.svg'
import sicon2 from '../images/icon/ser-icon02.svg'
import sicon3 from '../images/icon/ser-icon03.svg'
import sicon4 from '../images/icon/ser-icon04.svg'

import sdicon1 from '../images/icon/da-fea_icon01.svg'
import sdicon2 from '../images/icon/da-fea_icon02.svg'
import sdicon3 from '../images/icon/da-fea_icon03.svg'
import sdicon4 from '../images/icon/da-fea_icon04.svg'

import simg1 from '../images/service/service-img02.jpg'
import simg2 from '../images/service/service-img01.jpg'
import simg3 from '../images/service/service-img03.jpg'
import simg4 from '../images/service/service-img04.jpg'


import scicon1 from '../images/icon/airdrop-white.svg'
import scicon2 from '../images/icon/cloud-add.svg'
import scicon3 from '../images/icon/check02.svg'
import scicon4 from '../images/icon/finger-scan.svg'
import scicon5 from '../images/icon/ranking.svg'


import cdicon1 from '../images/icon/cd-ser_icon01.svg'
import cdicon2 from '../images/icon/cd-ser_icon02.svg'
import cdicon3 from '../images/icon/cd-ser_icon03.svg'
import cdicon4 from '../images/icon/cd-ser_icon04.svg'
import cdicon5 from '../images/icon/cd-ser_icon05.svg'
import cdicon6 from '../images/icon/cd-ser_icon06.svg'
import cdicon7 from '../images/icon/cd-ser_icon08.svg'
import cdicon8 from '../images/icon/cd-ser_icon09.svg'

// Service Detail Page Images
import srImg2 from '../images/hero/sd-img.png'
import vImg from '../images/video/img03.jpg'
import sImg1 from '../images/icon/sd-icon01.svg'
import sImg2 from '../images/icon/sd-icon02.svg'
import sImg3 from '../images/icon/sd-icon03.svg'
import sImg4 from '../images/icon/sd-icon04.svg'



const Services = [
    {
        Id: '1',
        sImg: icon1,
        title: 'Custom Software Development',
        slug: 'custom-software-development',
        thumb1: 'Web',
        thumb2: 'Mobile',
        description: 'Tailored enterprise solutions leveraging cutting-edge technologies for operational excellence.',
        // Service Detail Page Content
        detailPage: {
            pageTitle: 'Discover our comprehensive',
            pageTitleHighlight: 'Custom Software Development services',
            pageSubtitle: 'to transform your business operations',
            rightImage: srImg2,
            videoImage: vImg,
            videoId: '7e90gBu4pas',
            mainTitle: 'Build scalable solutions tailored to your business',
            content: [
                "In today's competitive digital landscape, custom software development is essential for businesses looking to gain a competitive edge. Our team specializes in creating bespoke applications that align perfectly with your unique business requirements, workflows, and objectives. By leveraging cutting-edge technologies and industry best practices, we deliver solutions that not only meet your current needs but also scale with your business growth.",
                "We follow an agile development methodology that ensures continuous collaboration, rapid iteration, and transparent communication throughout the project lifecycle. From initial concept to deployment and ongoing support, our experienced developers work closely with your team to ensure every feature delivers measurable business value. With a focus on quality, security, and performance, we create software that empowers your organization to operate more efficiently and serve your customers better."
            ],
            processTitle: 'Service process',
            processDescription: 'Our development process begins with a thorough requirements analysis and technical assessment, followed by iterative design and development sprints. We maintain regular communication and provide comprehensive testing to ensure optimal results and continuous improvement.',
            processSteps: [
                {
                    icon: sImg1,
                    title: 'Discovery & Planning',
                    description: 'Analyze requirements, define scope, and create technical roadmap.',
                    number: '01'
                },
                {
                    icon: sImg2,
                    title: 'Design & Architecture',
                    description: 'Create UI/UX designs and establish scalable system architecture.',
                    number: '02'
                },
                {
                    icon: sImg3,
                    title: 'Development & Testing',
                    description: 'Agile development with continuous integration and quality assurance.',
                    number: '03'
                },
                {
                    icon: sImg4,
                    title: 'Deployment & Support',
                    description: 'Launch solution and provide ongoing maintenance and updates.',
                    number: '04'
                }
            ],
            outcomeTitle: 'Services outcome',
            outcomeDescription: 'Here are six key benefits of custom software development in the context of digital transformation and scalable solutions for enterprises:',
            outcomes: [
                'Tailored Business Solutions',
                'Enhanced Operational Efficiency',
                'Scalable Architecture',
                'Competitive Advantage',
                'Seamless Integration',
                'Long-Term Cost Savings'
            ]
        }
    },
    {
        Id: '2',
        sImg: icon2,
        title: 'Cloud Solutions Architecture',
        slug: 'cloud-solutions-architecture',
        thumb1: 'Azure',
        thumb2: 'AWS',
        description: 'End-to-end cloud infrastructure design and optimization for scalable business operations.',
        detailPage: {
            pageTitle: 'Transform your infrastructure with',
            pageTitleHighlight: 'Cloud Solutions Architecture',
            pageSubtitle: 'designed for scalability and performance',
            rightImage: srImg2,
            videoImage: vImg,
            videoId: '7e90gBu4pas',
            mainTitle: 'Enterprise cloud architecture that drives business agility',
            content: [
                "Cloud Solutions Architecture represents the foundation of modern digital transformation. Our expert architects design and implement robust cloud infrastructures on Azure, AWS, and hybrid environments that align with your business objectives while ensuring optimal performance, security, and cost-efficiency. We analyze your current infrastructure, identify opportunities for cloud migration, and create a comprehensive roadmap that minimizes risk while maximizing the benefits of cloud technology.",
                "Our approach goes beyond simple lift-and-shift migrations. We design cloud-native architectures that leverage microservices, containerization, serverless computing, and advanced networking to create resilient, auto-scaling systems. With expertise in multi-cloud and hybrid cloud strategies, we help you avoid vendor lock-in while optimizing workload placement across different platforms. From initial assessment through deployment and ongoing optimization, our team ensures your cloud infrastructure delivers measurable business value, reduced operational costs, and the flexibility to adapt to changing market demands."
            ],
            processTitle: 'Our cloud architecture process',
            processDescription: 'We follow a comprehensive methodology that begins with infrastructure assessment and business alignment, followed by strategic architecture design and phased implementation. Our approach ensures minimal disruption while maximizing cloud benefits.',
            processSteps: [
                {
                    icon: sImg1,
                    title: 'Assessment & Strategy',
                    description: 'Evaluate current infrastructure and define cloud adoption strategy.',
                    number: '01'
                },
                {
                    icon: sImg2,
                    title: 'Architecture Design',
                    description: 'Design scalable, secure cloud architecture aligned with best practices.',
                    number: '02'
                },
                {
                    icon: sImg3,
                    title: 'Migration & Implementation',
                    description: 'Execute phased migration with zero-downtime deployment strategies.',
                    number: '03'
                },
                {
                    icon: sImg4,
                    title: 'Optimization & Management',
                    description: 'Continuous monitoring, cost optimization, and performance tuning.',
                    number: '04'
                }
            ],
            outcomeTitle: 'Cloud architecture benefits',
            outcomeDescription: 'Our cloud solutions architecture delivers transformative outcomes that enhance operational efficiency and business agility:',
            outcomes: [
                'Reduced Infrastructure Costs',
                'Enhanced Scalability & Flexibility',
                'Improved Security & Compliance',
                'Business Continuity & Disaster Recovery',
                'Accelerated Time-to-Market',
                'Global Performance & Availability'
            ]
        }
    },
    {
        Id: '3',
        sImg: icon3,
        title: 'Digital Transformation',
        slug: 'digital-transformation',
        thumb1: 'Strategy',
        thumb2: 'Implementation',
        description: 'Comprehensive modernization of business processes through technology integration.',
        detailPage: {
            pageTitle: 'Accelerate your business evolution',
            pageTitleHighlight: 'with Digital Transformation',
            pageSubtitle: 'strategies that deliver measurable results',
            rightImage: srImg2,
            videoImage: vImg,
            videoId: '7e90gBu4pas',
            mainTitle: 'Reimagine your business for the digital age',
            content: [
                "Digital Transformation is more than just adopting new technologies—it's a fundamental shift in how organizations operate, deliver value, and compete in the modern marketplace. Our comprehensive transformation services help enterprises modernize legacy systems, optimize business processes, and create digital-first customer experiences. We combine strategic consulting with hands-on implementation expertise to guide you through every phase of your transformation journey, ensuring alignment between technology investments and business outcomes.",
                "Our holistic approach addresses all dimensions of digital transformation: technology modernization, process automation, data-driven decision making, organizational change management, and cultural transformation. We help you leverage emerging technologies including cloud computing, artificial intelligence, Internet of Things, and advanced analytics to create new business models and revenue streams. With proven methodologies and industry best practices, we minimize disruption while maximizing adoption, ensuring your organization emerges more agile, efficient, and competitive. Our success is measured not just in technology deployment, but in tangible business results—increased revenue, reduced costs, improved customer satisfaction, and enhanced employee productivity."
            ],
            processTitle: 'Digital transformation roadmap',
            processDescription: 'Our structured approach combines strategic vision with tactical execution, beginning with comprehensive assessment and culminating in sustainable digital operations that drive continuous innovation.',
            processSteps: [
                {
                    icon: sImg1,
                    title: 'Vision & Assessment',
                    description: 'Define digital vision and assess current state maturity.',
                    number: '01'
                },
                {
                    icon: sImg2,
                    title: 'Strategy & Roadmap',
                    description: 'Develop transformation strategy and prioritized implementation roadmap.',
                    number: '02'
                },
                {
                    icon: sImg3,
                    title: 'Execute & Transform',
                    description: 'Implement solutions with agile methodology and change management.',
                    number: '03'
                },
                {
                    icon: sImg4,
                    title: 'Optimize & Scale',
                    description: 'Measure results, optimize processes, and scale successful initiatives.',
                    number: '04'
                }
            ],
            outcomeTitle: 'Transformation outcomes',
            outcomeDescription: 'Organizations that partner with us for digital transformation achieve significant competitive advantages and measurable business impact:',
            outcomes: [
                'Accelerated Innovation Cycles',
                'Enhanced Customer Experience',
                'Operational Excellence & Efficiency',
                'Data-Driven Decision Making',
                'Increased Market Agility',
                'Sustainable Competitive Advantage'
            ]
        }
    },
    {
        Id: '4',
        sImg: icon4,
        title: 'AI & Generative AI Solutions',
        slug: 'ai-generative-solutions',
        thumb1: 'Machine Learning',
        thumb2: 'LLM Integration',
        description: 'Enterprise-grade AI solutions leveraging generative models for innovative business applications.',
        detailPage: {
            pageTitle: 'Unlock unprecedented possibilities with',
            pageTitleHighlight: 'AI & Generative AI Solutions',
            pageSubtitle: 'that transform how you work and innovate',
            rightImage: srImg2,
            videoImage: vImg,
            videoId: '7e90gBu4pas',
            mainTitle: 'Harness the power of artificial intelligence for business transformation',
            content: [
                "Artificial Intelligence and Generative AI are revolutionizing how businesses operate, innovate, and deliver value to customers. Our comprehensive AI solutions span the entire spectrum from machine learning models and predictive analytics to cutting-edge generative AI applications powered by large language models. We help organizations identify high-value AI use cases, design ethical and responsible AI systems, and implement solutions that deliver measurable ROI. Whether you're looking to automate complex processes, enhance decision-making with predictive insights, or create innovative customer experiences with generative AI, our team brings deep expertise in both the technology and business application of AI.",
                "Our approach combines technical excellence with practical business acumen. We don't just deploy AI models—we create comprehensive solutions that integrate seamlessly with your existing systems, comply with regulatory requirements, and scale with your business needs. From natural language processing and computer vision to recommendation engines and intelligent automation, we leverage the latest advancements in AI technology including GPT models, neural networks, and reinforcement learning. Our solutions are built on robust MLOps practices ensuring model performance, monitoring, and continuous improvement. With expertise in both custom AI development and integration of leading AI platforms like Azure OpenAI, AWS SageMaker, and Google Vertex AI, we provide flexible solutions tailored to your specific requirements and constraints."
            ],
            processTitle: 'AI implementation methodology',
            processDescription: 'Our proven AI development process combines data science rigor with engineering excellence, ensuring solutions that are accurate, scalable, and aligned with business objectives.',
            processSteps: [
                {
                    icon: sImg1,
                    title: 'Discovery & Use Case',
                    description: 'Identify AI opportunities and validate business value propositions.',
                    number: '01'
                },
                {
                    icon: sImg2,
                    title: 'Data & Model Development',
                    description: 'Prepare data, train models, and optimize for accuracy and performance.',
                    number: '02'
                },
                {
                    icon: sImg3,
                    title: 'Integration & Deployment',
                    description: 'Deploy models with MLOps best practices and system integration.',
                    number: '03'
                },
                {
                    icon: sImg4,
                    title: 'Monitor & Optimize',
                    description: 'Continuous monitoring, retraining, and performance optimization.',
                    number: '04'
                }
            ],
            outcomeTitle: 'AI-powered business outcomes',
            outcomeDescription: 'Organizations implementing our AI solutions achieve transformative results across multiple dimensions of their business:',
            outcomes: [
                'Intelligent Process Automation',
                'Enhanced Decision Intelligence',
                'Personalized Customer Experiences',
                'Predictive Analytics & Forecasting',
                'Innovation & Competitive Differentiation',
                'Operational Cost Reduction'
            ]
        }
    },
    {
        Id: '5',
        sImg: icon5,
        title: 'Cybersecurity Solutions',
        slug: 'cybersecurity-solutions',
        thumb1: 'Enterprise',
        thumb2: 'Compliance',
        description: 'Full-spectrum security services protecting digital assets and ensuring regulatory compliance.',
        detailPage: {
            pageTitle: 'Protect your digital assets with',
            pageTitleHighlight: 'Comprehensive Cybersecurity Solutions',
            pageSubtitle: 'built on zero-trust principles',
            rightImage: srImg2,
            videoImage: vImg,
            videoId: '7e90gBu4pas',
            mainTitle: 'Enterprise-grade security that safeguards your business',
            content: [
                "In an era of sophisticated cyber threats and evolving regulatory requirements, comprehensive cybersecurity is not optional—it's essential for business survival. Our full-spectrum security services protect your organization's digital assets, intellectual property, and sensitive data from increasingly complex threats including ransomware, advanced persistent threats, insider risks, and supply chain attacks. We implement defense-in-depth strategies that combine preventive, detective, and responsive controls across your entire technology ecosystem. From zero-trust architecture and identity management to threat intelligence and incident response, our solutions provide the robust protection modern enterprises require.",
                "Our cybersecurity approach is built on industry-leading frameworks including NIST Cybersecurity Framework, CIS Controls, and ISO 27001 standards. We don't just implement security tools—we create comprehensive security programs that address people, processes, and technology. Our services span security assessment and risk management, security architecture design, implementation of advanced security controls, security operations center (SOC) services, compliance management for regulations like GDPR, HIPAA, and SOC 2, and executive security advisory. With 24/7 threat monitoring, AI-powered threat detection, and rapid incident response capabilities, we ensure your organization maintains a strong security posture while enabling business agility. Our team holds industry certifications including CISSP, CISM, CEH, and cloud security specializations, bringing deep expertise to every engagement."
            ],
            processTitle: 'Security implementation framework',
            processDescription: 'Our systematic security approach begins with comprehensive risk assessment and culminates in continuous threat monitoring and response, ensuring robust protection at every layer.',
            processSteps: [
                {
                    icon: sImg1,
                    title: 'Security Assessment',
                    description: 'Comprehensive vulnerability assessment and risk analysis.',
                    number: '01'
                },
                {
                    icon: sImg2,
                    title: 'Architecture & Design',
                    description: 'Design zero-trust architecture and security control framework.',
                    number: '02'
                },
                {
                    icon: sImg3,
                    title: 'Implementation & Hardening',
                    description: 'Deploy security controls and harden systems against threats.',
                    number: '03'
                },
                {
                    icon: sImg4,
                    title: 'Monitor & Respond',
                    description: '24/7 threat monitoring, incident response, and continuous improvement.',
                    number: '04'
                }
            ],
            outcomeTitle: 'Security outcomes',
            outcomeDescription: 'Organizations partnering with us for cybersecurity achieve comprehensive protection and compliance while maintaining business agility:',
            outcomes: [
                'Reduced Security Risk Exposure',
                'Regulatory Compliance Assurance',
                'Threat Detection & Response',
                'Data Protection & Privacy',
                'Business Continuity Resilience',
                'Security Culture & Awareness'
            ]
        }
    },
    {
        Id: '6',
        sImg: icon6,
        title: 'IT Infrastructure Management',
        slug: 'it-infrastructure-management',
        description: '24/7 monitoring and optimization of critical business technology systems.',
        detailPage: {
            pageTitle: 'Maximize uptime and performance with',
            pageTitleHighlight: 'Managed IT Infrastructure Services',
            pageSubtitle: 'ensuring always-on business operations',
            rightImage: srImg2,
            videoImage: vImg,
            videoId: '7e90gBu4pas',
            mainTitle: 'Proactive infrastructure management that keeps your business running',
            content: [
                "Modern businesses depend on reliable, high-performing IT infrastructure to maintain operations and deliver exceptional customer experiences. Our comprehensive IT Infrastructure Management services provide 24/7 monitoring, proactive maintenance, and rapid issue resolution for your entire technology ecosystem. We manage on-premises infrastructure, cloud environments, hybrid systems, networks, servers, storage, databases, and applications\u2014ensuring optimal performance, availability, and security. Our Infrastructure Management as a Service (IMaaS) model allows you to focus on core business initiatives while we handle the complexity of managing your technology infrastructure.",
                "Our approach combines advanced monitoring tools, automation, and human expertise to deliver superior infrastructure reliability. We implement Infrastructure as Code (IaC) for consistent, repeatable deployments, utilize AI-powered analytics for predictive maintenance and capacity planning, and employ automated remediation to resolve common issues before they impact users. With Service Level Agreements (SLAs) guaranteeing 99.9% uptime and mean time to resolution (MTTR) metrics, we provide the reliability enterprise operations demand. Our services include patch management, backup and disaster recovery, performance optimization, security hardening, compliance monitoring, and strategic technology planning. Whether you need full infrastructure outsourcing or co-managed services augmenting your internal IT team, we deliver flexible solutions tailored to your business requirements and budget."
            ],
            processTitle: 'Infrastructure management approach',
            processDescription: 'Our proven infrastructure management methodology ensures comprehensive coverage from initial onboarding through continuous optimization, with proactive monitoring and rapid response at every stage.',
            processSteps: [
                {
                    icon: sImg1,
                    title: 'Discovery & Onboarding',
                    description: 'Comprehensive infrastructure audit and service configuration.',
                    number: '01'
                },
                {
                    icon: sImg2,
                    title: 'Monitoring & Automation',
                    description: 'Deploy monitoring tools and implement automated management workflows.',
                    number: '02'
                },
                {
                    icon: sImg3,
                    title: 'Proactive Management',
                    description: '24/7 monitoring, patch management, and performance optimization.',
                    number: '03'
                },
                {
                    icon: sImg4,
                    title: 'Optimize & Evolve',
                    description: 'Continuous improvement, capacity planning, and strategic recommendations.',
                    number: '04'
                }
            ],
            outcomeTitle: 'Infrastructure management benefits',
            outcomeDescription: 'Organizations leveraging our managed infrastructure services achieve superior operational efficiency and reliability:',
            outcomes: [
                'Maximum System Uptime',
                'Predictable IT Costs',
                'Enhanced Security Posture',
                'Rapid Issue Resolution',
                'Scalable Infrastructure',
                'Strategic Technology Insights'
            ]
        }
    },
    {
        Id: '7',
        sImg: simg1,
        sIcon: sicon1,
        title: 'Enterprise Application Development',
        slug: 'enterprise-application-development',
    },
    {
        Id: '8',
        sImg: simg2,
        sIcon: sicon2,
        title: 'Data Analytics & BI Solutions',
        slug: 'data-analytics-bi-solutions',
    },
    {
        Id: '9',
        sImg: simg3,
        sIcon: sicon3,
        title: 'Brand Strategy & Digital Marketing',
        slug: 'brand-strategy-marketing',
    },
    {
        Id: '10',
        sImg: simg4,
        sIcon: sicon4,
        title: 'Full-Stack Development',
        slug: 'full-stack-development',
    },
    {
        Id: '11',
        sIcon: sdicon1,
        title: 'Cloud Migration Services',
        slug: 'cloud-migration',
        description: 'Seamless transition to Azure and hybrid cloud environments with zero downtime guarantees.',
    },
    {
        Id: '12',
        sIcon: sdicon2,
        title: 'DevOps Automation',
        slug: 'devops-automation',
        description: 'CI/CD pipeline implementation and infrastructure-as-code solutions for agile development.',
    },
    {
        Id: '13',
        sIcon: sdicon3,
        title: 'Generative AI Integration',
        slug: 'generative-ai-integration',
        description: 'Implementation of large language models and AI-powered business process automation.',
    },
    {
        Id: '14',
        sIcon: sdicon4,
        title: 'Digital Experience Platforms',
        slug: 'digital-experience-platforms',
        description: 'Omnichannel customer experience solutions with personalized engagement strategies.',
    },
    {
        Id: '15',
        sIcon: scicon1,
        title: 'Enterprise Cloud Security',
        slug: 'enterprise-cloud-security',
        features: ['Azure Security Implementation', 'Cloud Compliance Management', 'Zero Trust Architecture', 'Data Loss Prevention', 'Identity & Access Management']
    },
    {
        Id: '16',
        sIcon: scicon2,
        title: 'AI Development Services',
        slug: 'ai-development-services',
        features: ['Custom ML Solutions', 'Generative AI Models', 'Predictive Analytics', 'Natural Language Processing', 'Computer Vision Systems']
    },
    {
        id: '17',
        sIcon: scicon3,
        title: 'Transform your SOC',
        slug: 'Transform-your-SOC',
        features: [
            'Accelerate Threat Detection',
            'Automate Security Processes',
            'Streamline Incident Response',
            'Attack Surface Management',
            'Integrated Security Monitoring',
        ],
    },
    {
        id: '18',
        sIcon: scicon4,
        title: 'Threat Intel & Response',
        slug: 'Threat-Intel-&-Response',
        features: [
            "Let our experts be of your team.",
            "Move from reactive to proactive.",
            "Get world-class threat intelligence",
            "Every second counts when attack",
            "Make our experience your experience",
        ],
    },
    {
        id: '19',
        sIcon: scicon5,
        title: 'Solutions by industry',
        slug: 'Solutions-by-industry',
        features: [
            'Public sector',
            'Financial services',
            'Manufacturing',
            'Small & medium business solutions',
            'Healthcare',
        ],
    },

    {
        Id: '20',
        sIcon: cdicon1,
        title: 'INFRASTRUCT URE DESIGN',
        slug: 'INFRASTRUCT-URE-DESIGN',
    },
    {
        Id: '21',
        sIcon: cdicon2,
        title: 'COSTS OPTIMIZATION',
        slug: 'COSTS-OPTIMIZATION',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '22',
        sIcon: cdicon3,
        title: 'INFRASTRUCTURE AS A CODE',
        slug: 'INFRASTRUCTURE-AS-A-CODE',
        bgClass:'cd-dot_bg3',
    },
    {
        Id: '23',
        sIcon: cdicon4,
        title: 'Continuous Integration',
        slug: 'Continuous-Integration',
        bgClass:'cd-dot_bg4',
    },
    {
        Id: '24',
        sIcon: cdicon5,
        title: 'Continuous Deployment',
        slug: 'Continuous-Deployment',
    },
    {
        Id: '25',
        sIcon: cdicon6,
        title: 'Blue Green Deployment',
        slug: 'Blue-Green-Deployment',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '26',
        sIcon: '',
        title: 'Data Consistency',
        slug: 'Data-Consistency',
        bgClass:'cd-dot_bg3'
    },
    {
        Id: '27',
        sIcon: cdicon7,
        title: 'Data Integrity',
        slug: 'Data-Integrity',
        bgClass:'cd-dot_bg4'
    },
    {
        Id: '28',
        sIcon: cdicon8,
        title: 'Redundancy',
        slug: 'Redundancy',
    },
]

export default Services;